module.exports = __webpack_public_path__ + "img/bible-mission.3e9146e1.jpg";